import Review from 'scenes/CampaignCenter/Builder/Steps/Reputation/Review'
import Messaging from 'scenes/CampaignCenter/Builder/Steps/Reputation/Review/Messaging'
import Success from 'scenes/CampaignCenter/Builder/Steps/Shared/Success'

export default {
  steps: {
    required: {
      review: Review,
      success: Success,
    },
    optional: {
      messaging: Messaging,
    },
  },
  options: {
    initialStep: 'review',
    disableNavFor: {
      success: true,
    },
  },
}
